import { useEffect, useState } from 'react';
import { supabase } from '../../services/supabaseService';
import { type MfaFactor } from '../../services/mfaService';
import AuthenticatorForm from './AuthenticatorForm';

export default function MfaSettings() {
  const [factors, setFactors] = useState<MfaFactor[]>([]);
  const [adding, setAdding] = useState(false);
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(true);
  const load = async () => {
    setBusy(true); setError('');
    const result = await supabase.auth.mfa.listFactors();
    if (result.error) setError('No se han podido consultar tus autenticadores.');
    else setFactors(result.data.all.filter(f => f.status === 'verified'));
    setBusy(false);
  };
  useEffect(() => { void load(); }, []);
  const remove = async (id: string) => {
    if (!window.confirm('¿Retirar este autenticador? Necesitarás el otro para acceder.')) return;
    setBusy(true); setError('');
    // Recheck immediately before mutation. Never offer removal of the last factor.
    const current = await supabase.auth.mfa.listFactors();
    if (current.error || current.data.all.filter(f => f.status === 'verified' && f.factor_type === 'totp' && f.id !== id).length < 1) {
      setError('Primero vincula y verifica otro autenticador.'); setBusy(false); return;
    }
    const result = await supabase.auth.mfa.unenroll({ factorId: id });
    if (result.error) { setError('No se ha podido retirar el autenticador.'); setBusy(false); return; }
    await supabase.auth.refreshSession();
    await load();
  };
  return <section className="border-t pt-4 space-y-3">
    <h4 className="text-sm font-medium">Segundo factor de autenticación</h4>
    {error && <p role="alert" className="text-sm text-red-700">{error}</p>}
    {busy && <p role="status" className="text-sm text-gray-600">Comprobando autenticadores…</p>}
    {!busy && <p className="text-sm text-gray-600">{factors.length ? 'Activado. Se te pedirá un código al iniciar una nueva sesión.' : 'Pendiente de vincular una aplicación autenticadora.'}</p>}
    <ul className="space-y-2">{factors.map(f => <li key={f.id} className="flex items-center justify-between gap-3 text-sm"><span>{f.friendly_name || 'Aplicación autenticadora'}</span>{factors.filter(item => item.factor_type === 'totp' && item.id !== f.id).length > 0 && <button disabled={busy} onClick={() => void remove(f.id)} className="text-red-700 underline">Retirar</button>}</li>)}</ul>
    {adding ? <><AuthenticatorForm enroll onVerified={() => { setAdding(false); void load(); }} /><button onClick={() => setAdding(false)} className="text-sm underline">Cancelar</button></> : <button disabled={busy} onClick={() => setAdding(true)} className="text-sm text-blue-700 underline">{factors.length ? 'Añadir otro autenticador de respaldo' : 'Configurar segundo factor'}</button>}
    <p className="text-xs text-gray-500">Conserva un autenticador de respaldo. Si pierdes todos, la recuperación requiere la intervención del administrador de Supabase.</p>
  </section>;
}
